<template>
  <div class="flex items-center justify-center">
    <div class="w-full sm:max-w-xl md:max-w-3xl lg:max-w-5xl xl:max-w-7xl">
      <slot />
    </div>
  </div>
</template>
